
    import './styles.scoped.css';
    export default {
  "wrapper": "awsui_wrapper_1wepg_w4m5k_93",
  "label-wrapper": "awsui_label-wrapper_1wepg_w4m5k_100",
  "content": "awsui_content_1wepg_w4m5k_105",
  "empty-content": "awsui_empty-content_1wepg_w4m5k_111",
  "description": "awsui_description_1wepg_w4m5k_115",
  "description-bottom-padding": "awsui_description-bottom-padding_1wepg_w4m5k_121",
  "label": "awsui_label_1wepg_w4m5k_100",
  "label-disabled": "awsui_label-disabled_1wepg_w4m5k_129",
  "description-disabled": "awsui_description-disabled_1wepg_w4m5k_130",
  "control": "awsui_control_1wepg_w4m5k_135",
  "outline": "awsui_outline_1wepg_w4m5k_138"
};
  